import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-controladoria-nav',
  template: `
    <nav class="controladoria-nav nav nav-pills mb-4" aria-label="Controladoria">
      <a
        class="nav-link"
        [class.active]="isCostCentersTab()"
        routerLink="/financial/cost-centers">
        Centros de custo
      </a>
      <a
        class="nav-link"
        [class.active]="isBudgetProposalsTab()"
        routerLink="/financial/budget-proposals">
        Propostas de orçamento
      </a>
      <a
        class="nav-link"
        [class.active]="isConsolidatedStatisticsTab()"
        routerLink="/financial/cost-centers/consolidated-statistics">
        Estatísticas consolidadas
      </a>
    </nav>
  `,
  styles: [
    `
      .controladoria-nav .nav-link {
        color: #374151;
        font-weight: 500;
      }
      .controladoria-nav .nav-link.active {
        background: var(--primary-color, #2563eb);
        color: #fff;
      }
    `
  ]
})
export class ControladoriaNavComponent {
  constructor(private router: Router) {}

  isCostCentersTab(): boolean {
    const url = this.router.url.split('?')[0];
    if (url.startsWith('/financial/budget-proposals')) {
      return false;
    }
    if (this.isConsolidatedStatisticsTab()) {
      return false;
    }
    return url.startsWith('/financial/cost-centers');
  }

  isConsolidatedStatisticsTab(): boolean {
    const url = this.router.url.split('?')[0];
    return url.startsWith('/financial/cost-centers/consolidated-statistics');
  }

  isBudgetProposalsTab(): boolean {
    const url = this.router.url.split('?')[0];
    return url === '/financial/budget-proposals' || url.startsWith('/financial/budget-proposals/');
  }
}
